import React from 'react';

/**
 * 参数值编辑器的结算上下文：用来判断 expiry 是否已到期。
 *
 * - exchange + currency 都已知（BOT 默认值）：按该 (交易所, 标的) 的精确结算规则；
 * - 只知道 currency（ASSET 默认值）：按该标的可能的最晚结算规则；
 * - 都未知（GLOBAL 默认值）：按所有规则里最晚的时刻，宁可多显示几小时也不提前隐藏。
 *
 * 后端在读写两侧都会按精确规则再过滤一次，前端只负责展示时隐藏。
 */
export interface SettleScope {
  exchange?: string;
  currency?: string;
}

export const SettleContext = React.createContext<SettleScope>({});

/** 从 botCode（形如 B_BYBIT-NVDA-<CONSOLE>_<TEAM>-<NAME>）解析交易所与标的 */
export function settleScopeFromBotCode(botCode?: string): SettleScope {
  if (!botCode) return {};
  const body = botCode.replace(/^B_/, '');
  const [exchange, currency] = body.split('-');
  if (!exchange || !currency) return {};
  return { exchange: exchange.toUpperCase(), currency: currency.toUpperCase() };
}
